import { render, staticRenderFns } from "./Appraisal.vue?vue&type=template&id=1d80ec88&scoped=true&"
import script from "./Appraisal.vue?vue&type=script&lang=js&"
export * from "./Appraisal.vue?vue&type=script&lang=js&"
import style0 from "./Appraisal.vue?vue&type=style&index=0&id=1d80ec88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d80ec88",
  null
  
)

export default component.exports